import {useState, useEffect} from 'react';
import wcmUtils from '../utils/wcmUtils';

export default function useLoadWebModule() {
  const [sdkLoaded, setSdkLoaded] = useState(false);

  useEffect(() => {
    if (window.YMK) {
      setSdkLoaded(true);
      return;
    }
    (async () => {
      await wcmUtils.loadWebModule();
      setSdkLoaded(true);
    })();
  }, []);

  return {sdkLoaded};
}
